"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;
var _domains = require("./domains");
Object.keys(_domains).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _domains[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _domains[key];
    }
  });
});
var _emailMisspelled = require("./emailMisspelled");
var _default = _emailMisspelled.emailMisspelled;
exports["default"] = _default;